module.exports = __webpack_public_path__ + "img/bsg_bg.92f4477d.jpg";